import React from 'react';
import PropTypes from 'prop-types';

const ResearchFocusAreas = ({ focusAreas, backgroundImage }) => {
  return (
    <section className="py-12 md:py-16 lg:py-20 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 primary-bg"></div>
      </div>

      <div className="relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16 px-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Explore Comprehensive Support for <span className="secondary-text">Your Mental Well-Being</span>
          </h2>
          <p className="text-md md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Visit our New Clients page to get started. Review the insurance plans we accept or reach out to our team for assistance.
          </p>
        </div>

        {/* Cards Grid - 3 per row, 2 rows = 6 cards */}
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {focusAreas.slice(0, 6).map((area, index) => (
              <div
                key={area.id || index}
                className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                {/* Image */}
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={area.image}
                    alt={area.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Content */}
                <div className="p-5 md:p-6 bg-white">
                  <h3 className="text-lg md:text-xl font-bold mb-3 text-center border-b-2 border-gray-200">
                    <span className="primary-text">{area.title}</span>
                  </h3>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed text-center">
                    {area.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

ResearchFocusAreas.propTypes = {
  focusAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  backgroundImage: PropTypes.string.isRequired,
};

export default ResearchFocusAreas;